/**
 * Which of the two API-KEY apps this bundle is running as.
 *
 * The console (index.html) and the Driver App (driver.html) are served from
 * the same origin, so they share one localStorage. When both persisted their
 * session under the same key they stomped each other: signing into
 * /driver.html wrote a driver session, the console tab then wrote its admin
 * session back over it, and the driver tab bounced to the login screen on
 * its next load — a successful login that looked like a failed one. A 401 in
 * either app also signed the other one out.
 *
 * Detected from the mount point in the entry HTML rather than from the URL,
 * because the driver bundle is not guaranteed to be served at /driver.html
 * (Telegram points a Mini App at whatever URL it is given). Module scripts
 * are deferred, so the DOM is parsed by the time this runs.
 *
 * The B2B client portal (client.html) is a THIRD entry point on this origin
 * and is deliberately outside this scheme: it holds a portal session token,
 * not an API key, and keeps it under its own key in src/client/clientApi.js.
 * Note that the check below would classify it as 'console' — harmless only
 * because the client bundle never imports authStore. Anything in this file
 * that the portal starts using needs a real third scope first, or the portal
 * and the console will stomp each other exactly as the console and the
 * Driver App once did.
 */
export const APP_SCOPE =
  typeof document !== 'undefined' && document.getElementById('driver-root') ? 'driver' : 'console';

export const AUTH_STORAGE_KEY = `aragela_auth_${APP_SCOPE}`;

/** Language and other display preferences stay shared on purpose — a driver
 *  who picks EN should not have to pick it again in the console. */
export const UI_STORAGE_KEY = 'aragela_ui';
